export const REAL_ESTATE_AGENT_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "RealEstateAgent",
  name: "Immozwerg – Andrea Heinz · HAJ Immo e.K.",
  url: "https://immozwerg.com",
  logo: "/assets/745663e22c7f.png",
  image: "/assets/abfc58b6e93e.webp",
  description: "Immobilienmaklerin Andrea Heinz – Ihr persönlicher Ansprechpartner für Immobilienverkauf, Kaufbegleitung und Finanzierungsvermittlung in Güglingen, Brackenheim, Meimsheim, Lauffen am Neckar, Kirchheim am Neckar, Schwaigern, Leingarten, Heilbronn, Böckingen und dem Zabergäu.",
  telephone: "+491738660756",
  email: "hallo@haj-immokg.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Lortzingstraße 5",
    postalCode: "74363",
    addressLocality: "Güglingen",
    addressRegion: "Baden-Württemberg",
    addressCountry: "DE",
  },
  areaServed: [
    { "@type": "City", name: "Brackenheim" },
    { "@type": "City", name: "Güglingen" },
    { "@type": "City", name: "Heilbronn" },
    { "@type": "City", name: "Lauffen am Neckar" },
    { "@type": "Place", name: "Meimsheim" },
    { "@type": "City", name: "Kirchheim am Neckar" },
    { "@type": "City", name: "Schwaigern" },
    { "@type": "City", name: "Leingarten" },
    { "@type": "Place", name: "Böckingen" },
    { "@type": "City", name: "Zabergäu" },
    { "@type": "City", name: "Stuttgart" },
  ],
  priceRange: "Kostenlose Erstberatung",
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:00",
      closes: "18:00",
    },
  ],
  sameAs: [
    "https://www.instagram.com/immozwerg",
    "https://www.facebook.com/profile.php?id=61572975815321",
    "https://www.linkedin.com/in/andrea-heinz-822596145/",
  ],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "5.0",
    reviewCount: "15",
    bestRating: "5",
    worstRating: "1",
  },
  review: [
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Florian K." },
      datePublished: "2026-07-22",
      reviewRating: { "@type": "Rating", ratingValue: "5", bestRating: "5" },
      reviewBody: "Bei Andrea fühlt man sich bestens aufgehoben. Die Beratung und Betreuung ist überragend. Von Besichtigung bis zum Notartermin hat alles reibungslos funktioniert. Vielen Dank!",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Clemens K." },
      datePublished: "2026-07-22",
      reviewRating: { "@type": "Rating", ratingValue: "5", bestRating: "5" },
      reviewBody: "Wirklich eine super Maklerin. Ich habe mit Andrea von der Besichtigung bis zur notariellen Beglaubigung des Kaufvertrags eine durch und durch positive Erfahrung gemacht.",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Maurice S." },
      datePublished: "2026-07-22",
      reviewRating: { "@type": "Rating", ratingValue: "5", bestRating: "5" },
      reviewBody: "Zuverlässig, Kompetent und vor allem ein reibungsloser Ablauf. Frau Heinz war jederzeit erreichbar und sämtliche Anliegen konnten immer schnell und einfach abgesprochen und abgeklärt werden.",
    },
  ],
} as const;
